export const important = <T>(value: T) => {
  return `${value.toString()} !important` as unknown as T;
};
